// Client API du périmètre DPO — endpoint /api/v1/dpo/* (backend core).
// Accès réservé au DPO désigné (est_dpo) ou ADMIN ; le backend renvoie 403
// sinon (gere cote page via getApiErrorDetail).
import { apiClient } from "@/lib/api";

export interface RiskRegisterEntry {
  id: string;
  code: string;
  libelle: string;
  probabilite: string;
  impact: string;
  niveau: string;
  mesures_existantes: string[];
  mesures_planifiees: string[];
  occurrences: number;
}

export async function getRiskRegister(): Promise<RiskRegisterEntry[]> {
  const { data } = await apiClient.get<RiskRegisterEntry[]>(
    "/api/v1/dpo/risk-register",
  );
  return Array.isArray(data) ? data : [];
}

export interface DpoStatus {
  authorized: boolean;
}

export async function getDpoStatus(): Promise<DpoStatus> {
  const { data } = await apiClient.get<DpoStatus>("/api/v1/dpo/status");
  return data;
}
